module.exports = __webpack_public_path__ + "static/media/cup.56a296dc.png";